import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/qs-logo.png'


const _hoisted_1 = {
  class: "modal fade",
  ref: "launchUserTutorialIntro",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row h-100" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-10 my-auto" }, [
      /*#__PURE__*/_createElementVNode("h2", { class: "ps-3" }, "Welcome to QuickSource")
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fst-italic" }, "Click Start Tour"),
  /*#__PURE__*/_createTextVNode(" to learn the basics. Then, follow the steps in the QuickSource Guide to complete your comps and send them to TOTAL.")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "You can always relaunch the QuickSource Tour from the QuickSource Guide located at the bottom of the screen.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalBody = _resolveComponent("ModalBody")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ModalBody, null, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_ModalFooter, null, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startTour && _ctx.startTour(...args)))
            }, "Start Tour")
          ]),
          _: 1
        })
      ])
    ])
  ], 512))
}